import { __rest } from '../../_virtual/_tslib.js';
import React__default from 'react';
import classNames from 'classnames';
import LazyFadeIn from '../lazy-fade-in/LazyFadeIn.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import { IMG_BASE_URL } from '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import 'bowser';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../constants/StateList.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../../constants/serviceTypeId.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';
import Styles from './AvatarImage.module.scss.js';

const AvatarImage = (_a) => {
    var { size = "xs" } = _a, props = __rest(_a, ["size"]);
    const { imageSize } = props;
    const { imageUrl, alt, firstName, lastName, defaultUrl, className, onClick } = props;
    const sizes = {
        xs: 36,
        sm: 45,
        md: 60,
        lg: 100,
        custom: imageSize
    };
    const initial = [];
    if (firstName || lastName) {
        if (firstName) {
            initial.push(firstName[0]);
        }
        if (lastName) {
            initial.push(lastName[0]);
        }
    }
    return (React__default.createElement("div", { className: classNames(Styles.imageContainer, className), onClick: onClick },
        React__default.createElement(LazyFadeIn, null, (onLoad) => (React__default.createElement("img", { src: imageUrl || defaultUrl || `${IMG_BASE_URL}/default.png`, alt: alt, onLoad: onLoad, width: sizes[size], height: sizes[size] })))));
};

export { AvatarImage as default };
//# sourceMappingURL=AvatarImage.js.map
